import noop from 'lodash.noop';

import { createLegacyHistory } from './utils/create-legacy-history';
import { BrowserHistory } from './types';

export const DEFAULT_LOCATION = { pathname: '', search: '', hash: '' };

export const DEFAULT_MATCH = {
	params: {},
	isExact: false,
	path: '',
	url: '',
	query: {},
};

export const DEFAULT_ROUTE = {
	path: '',
	component: () => null,
	name: '',
};

export const DEFAULT_HISTORY: BrowserHistory = createLegacyHistory();

export const NOOP_HISTORY: {
	location: {
		pathname: string;
		search: string;
		hash: string;
	};
	push: (...args: any[]) => void;
	replace: (...args: any[]) => void;
	goBack: (...args: any[]) => void;
	goForward: (...args: any[]) => void;
	listen: (...args: any[]) => void;
	block: (...args: any[]) => void;
	createHref: (...args: any[]) => void;
} = {
	location: DEFAULT_LOCATION,
	push: noop,
	replace: noop,
	goBack: noop,
	goForward: noop,
	listen: noop,
	block: noop,
	createHref: noop,
};

export const DEFAULT_ACTION = 'POP';
